import { ClearFavoritesType } from '../interfaces'

const ClearFavorites = ({ handleClear }: ClearFavoritesType) => {
  return (
    <button
      type="button"
      onClick={handleClear}
      className="wc-link no-print"
      name="clear favourites"
    >
      Clear all favourites
    </button>
  )
}

export default ClearFavorites
